import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import { PageTitle } from '../common/components/PageTitle';
import { EmailsService } from '../api/EmailsService';
import { Spinner } from '../common/components/Spinner';
import { useParams } from 'react-router-dom';

const ConfirmEmailPage = () => {
    const { token } = useParams();
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        // Re-run for each token: opening a second confirm link in the same tab only changes
        // the hash route, so this component instance is reused and useParams() hands us a new
        // token without a remount. The `ignore` guard drops a late response from a superseded
        // token so it can't overwrite the current token's result.
        let ignore = false;
        setIsLoading(true);
        setError(null);
        EmailsService.confirm(token)
            .then(() => {
                if (!ignore) setIsLoading(false);
            })
            .catch((err) => {
                if (ignore) return;
                setError(err.message);
                setIsLoading(false);
            });
        return () => {
            ignore = true;
        };
    }, [token]);

    if (isLoading) {
        return <Spinner />;
    }

    return (
        <>
            <PageTitle sx={{ pt: 8 }}>{t('confirmEmail.title')}</PageTitle>
            <Box sx={(theme) => theme.mixins.box(theme)}>
                <Box sx={{ pt: 0.5, pb: 1, maxWidth: '900px' }}>
                    <Typography variant="h5" sx={{ mb: 3, textAlign: 'center' }}>
                        {error ? t('confirmEmail.error') : t('confirmEmail.success')}
                    </Typography>
                </Box>
            </Box>
        </>
    );
};

export { ConfirmEmailPage };
